<template>
  <div class="search">
    <!-- 搜索表单 -->
    <div class="search-head">
      <span class="iconfont icon-search search-icon"></span>
      <i v-if="value.length" @click="handelClose()" class="iconfont icon-close-circle-solid close"></i>
      <input class="search-inp" type="text" placeholder="请输入查询信息" ref="inp" @keyup.enter="onSearch(value)" v-model.trim="value"  @input="onSearch(value)">
      <span @click="onCancel" class="backtrack">{{$t('common.cancel')}}</span>
    </div>
    <div v-if="isShow" class="search-show">
      <!-- 历史记录 -->
      <div v-if="list.length" class="search-history">
        <h4 class="search-history">搜索历史</h4>
        <ul>
          <li v-for="(item, index) in list" :key="index"><span class="content" @click="handelEcho(item)" >{{ item }}</span> <van-icon @click="handelDel(index)" name='cross' /> </li>
        </ul>
        <!-- 清楚历史记录 -->
        <div class="clear-history"><van-button @click="clearHistory()" class="butt" size="normal" type="default">清空历史</van-button></div>
      </div>
      <div class="no-history" v-else>
        <img src="../../assets/img/no_search.png" alt="">
        <p>输入关键字进行搜索</p>
      </div>
    </div>
    <SearchResult @trigger="trigger"
      ref="search"
      @getFocus="getFocuschil"
      :value="value"
      :searchList="searchList"
      v-else />
  </div>
</template>

<script>
import SearchResult from './components/SearchResult.vue'
export default {
  name: "Search",
  data() {
    return {
      list: JSON.parse(localStorage.getItem("HISTORY")) || [],
      value: '',
      isShow: true,
      searchList: [],
      index: 0,
      flage: false
    }
  },
  watch: {
    list: {
      handler(newValue, oldValue) {
        localStorage.setItem("HISTORY", JSON.stringify(newValue))
      },
      deep: true,
      immediate: true
    },
    $route(to,from) {
          this.getFocus()
    }
  },
  created() {
    this.$bus.$on('changeShow', (item) => {
			// console.log('changeShow', item)
      this.isShow = item
      this.value = ''
		})
  },
  mounted() {
    this.getFocus()
  },
  methods: {
    // 表单搜索时的函数
    onSearch(val) {
      // console.log(val)
        clearTimeout(this.tiem)
        this.tiem = setTimeout( async () => {
          if (val !== '') {
             this.isShow = false
             if (this.list.length > 5) {
               this.list.splice(this.list.length - 1, 1)
             }
             if (!this.list.includes(val)){
               this.list.unshift(val)
             } else {
               let index = this.list.indexOf(val)
               this.list.splice(index, 1)
               this.list.unshift(val)
             }
            this.searchList = []
              this.$nextTick(() => {

                // this.$refs.search.test()
                this.$refs.search.allList = []
                this.$refs.search.finished = false
                this.$refs.search.refreshing = true
                if (this.flage) {
                  this.$refs.search.onRefresh()
                }
                this.flage = true
              })
              // 每次搜索都会回到顶部
              document.querySelector(".van-tabs__content").scrollTop = 0
          }
        }, 800);
    },
    // 取消按钮
    onCancel() {
      this.value = ''
      this.searchList = []
      this.allList=[]
      this.flage = false
      this.isShow = true
      this.$router.go(-1)
    },
    // 清除搜索框里的内容
    onClear() {
      this.isShow = true
    },
    // 删除
    handelDel(index) {
      this.list.splice(index, 1)
    },
    // 清空历史记录
    clearHistory() {
      localStorage.removeItem("HISTORY")
      this.list = JSON.parse(localStorage.getItem("HISTORY")) || []
      this.getFocus()
    },
    // 点击历史搜索回显
    handelEcho(val) {
      this.value = val
      this.onSearch(val)
    },
    // 保存索引
    trigger(ind) {
      this.index = ind
    },
    // 清除搜索框内容
    handelClose() {
      this.value = ''
      this.isShow = true
      this.searchList = []
      this.$refs.search.allList = []
      this.flage = false
      this.index = 0
      this.getFocus()
    },
    // 获取焦点
    getFocus() {
      this.$refs.inp.focus()
    },
    getFocuschil() {
      this.getFocus()
    }
  },
  components: {
    SearchResult,
  },
  mounted() {
    this.value = ''
    this.allList = []
    this.getFocus()
  }
}
</script>

<style scoped lang="less">
.search {
  height: 100vh;
  overflow: hidden;
  padding: 0 10px;
  .van-search {
    padding: 0;
  }
  .van-search__action {
    color: #005DE5;
  }
  .search-head {
    position: fixed;
    top: 8px;
    width: 70%;
    height: 44px;
    background-color: #F2F3F5;
    padding: 0 5px 0 30px;
    margin-right: 44px;
    border-radius: 5px;
    z-index: 9999;
    .search-inp {
      width: 100%;
      height: 44px;
      padding: 0;
      border: none;
      background-color: #F2F3F5;
      outline: none;
    }
    .search-icon {
      position: absolute;
      top: 14px;
      left: 8px;
      font-size: 14px;
    }
    .backtrack {
      position: absolute;
      top: 15px;
      right: -43px;
      color: #005DE5;
    }
    .close {
      position: absolute;
      top: 13px;
      right: 7px;
    }
  }
  .search-history {
    margin-top: 20px;
    h4 {
      color: #666666;
      font-weight: 400;
      font-size: 12px;
      text-align: left;
    }
    li {
      position: relative;
      height: 46px;
      line-height: 46px;
      font-size: 14px;
      font-weight: 700;
      text-align: left;
      &:nth-of-type(1) {
        margin-top: 8px;
      }
      .van-icon {
        position: absolute;
        top: 16px;
        right: 0;
        font-weight: 700;
      }
      .content {
        display: inline-block;
        width: 300px;
      }
    }
  }
  .clear-history {
    margin-top: 20px;
    text-align: center;
    .butt {
      width: 140px;
      height: 36px;
    }
  }
 .search-history {
   margin-top: 80px;
 }
 .no-history {
   margin-top: 160px;
    display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
    img {
			width: 125px;
			height: 125px;
		}
		p {
			font-size: 14px;
			color: #666666;
			line-height: 21px;
		}
 }
}

</style>